$(document).ready(function() {
    $(document).on("click", ".remove-item", function(e) {
        e.preventDefault();
        $target = $(this);
        //show the removing text until it is handled.
        $(".remove-item").toggleClass("hidden");
        $(".removeing-item").toggleClass("hidden")
        var variant_id = $target.attr("data-variant-id");
        jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js', 
            data: { quantity: 0, id: variant_id }, 
            dataType: 'json',
            success: function() { location.href = '/cart'; }
         });
    });
});